$(window).resize(function(){
  
  if ($(window).width() > 640 ){
  
    $( ".container > .row" ).each(function(){
      var tallest = 0;

      $( this ).find( ".floating-card" ).each(function(){
        $( this ).css( "min-height", 0 );
        var cur_height = $( this ).height();

      $( this ).find( ".floating-card" ).css( "min-height", tallest );
        tallest =  ((tallest < cur_height) ? cur_height : tallest);
      });

      $( this ).find( ".floating-card" ).css( "min-height", tallest );

    });
  }
  
}).resize();